import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IDataGridColumn, ISortEvent } from "@schema/data-grid";
import { IEntity } from "@schema/entity";
import { IHttpResponse, IHttpRequestOptions } from "@schema/http";
import { Subject, BehaviorSubject } from "rxjs";
import { MessageType } from "@schema/message";

@Component({
  selector: "app-data-grid",
  templateUrl: "./data-grid.component.html",
  styleUrls: ["./data-grid.component.scss"]
})
export class DataGridComponent<TGenericEntity extends IEntity> implements OnInit {

  /**
   * The name of the entity, to show in an empty grid / create buttons
   */
  @Input()
  public entityName = "item";

  /**
   * The name of the entity, to show in an empty grid / create buttons
   */
  @Input()
  public createUrl = "./new";

  /**
   * The columns to be displayed in the grid
   */
  @Input()
  public columns: IDataGridColumn[] = [];

  /**
   * The entities to be loaded in
   */
  @Input()
  public entities$: BehaviorSubject<IHttpResponse<TGenericEntity[]>>;

  /**
   * The loading status
   */
  @Input()
  public loading$: BehaviorSubject<boolean>;

  /**
   * The error status for entities loading in
   */
  @Input()
  public error$: BehaviorSubject<string>;
  public errorType = MessageType.ERROR;

  /**
   * Event for when sorting or navigating pagination is needed
   */
  @Output()
  public loadEntities: EventEmitter<IHttpRequestOptions> = new EventEmitter();

  /**
   * The current sort information
   */
  public sortedColumn: ISortEvent;

  /**
   * A singleton of the request options to keep sorting across pagination
   *
   * @todo: move this to page URL for better ux
   */
  protected _requestOptions: IHttpRequestOptions = {
    pageNumber: 1,
  };

  constructor() { }

  ngOnInit(): void { }

  /**
   * Sort the entities
   */
  public sort(sort: ISortEvent): void {
    this._requestOptions = {
      orderBy: `${sort.column}:${sort.direction}`
    };
    this.sortedColumn = sort;
    this.loadEntities.emit(this._requestOptions);
  }

  /**
   * Change the page number
   */
  public goToPage(pageNumber: number): void {
    if (pageNumber === this._requestOptions.pageNumber) {
      return;
    }
    this._requestOptions = Object.assign(this._requestOptions, { pageNumber });
    this.loadEntities.emit(this._requestOptions);
  }

}
